// Работното време на заведението (Конфигурация → Работно време) за чистата
// логика извън React. Ползва се САМО на две места:
//   • часовете по подразбиране в справките с час — `lib/businessDay.ts`;
//   • часовете, в които формата за резервации приема начало —
//     `pages/reservations/logic/workingSlots.ts`.
// Нищо друго не бива да го чете.
//
// Стойността идва от `/user/info` (`configuration.workingHours`); `store.ts` я
// подава тук при всяка промяна на store-а. null — още не е настроено: тогава
// и двете места остават на досегашните си часове.

import type { WorkingDay } from "../api/configuration";

const DAYS_IN_WEEK = 7;

let currentWorkingHours: WorkingDay[] | null = null;

export const setWorkingHours = (workingHours: WorkingDay[] | null | undefined) => {
  currentWorkingHours =
    workingHours && workingHours.length === DAYS_IN_WEEK ? workingHours : null;
};

export const getWorkingHours = (): WorkingDay[] | null => currentWorkingHours;

/** "HH:MM" → минута от денонощието. */
export const minutesOfTime = (time: string): number => {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

/** Денят затваря след полунощ (затварянето е до или преди отварянето). */
export const crossesMidnight = (day: WorkingDay): boolean =>
  !day.closed && minutesOfTime(day.closesAt) <= minutesOfTime(day.opensAt);

/**
 * Работното време на деня от седмицата по JS `getDay()` (0 = неделя);
 * null — не е настроено. В настройката понеделник е първи.
 */
export const workingDayOf = (jsWeekday: number): WorkingDay | null =>
  currentWorkingHours?.[(jsWeekday + 6) % DAYS_IN_WEEK] ?? null;
